import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrepaidComponent } from './prepaid/prepaid.component';
import { DthComponent } from './dth/dth.component';
import { ElectricityComponent } from './electricity/electricity.component';
import { StatementComponent } from './statement/statement.component';
import { RetailerComponent } from './retailer/retailer.component';

const routes: Routes = [
  { path: '', component: PrepaidComponent },
  { path: 'prepaid-recharge', component: PrepaidComponent },
  { path: 'dth-recharge', component: DthComponent },
  { path: 'electricity-bill', component: ElectricityComponent },
  { path: 'statement', component:StatementComponent },
  { path: 'retailer', component:RetailerComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
